import CryptoJS from "crypto-js";
import forge from "node-forge";
import { getPublicKey } from "../api/methods";
import { paths } from "../api/paths";
import { geoLocationErrorMessage } from "../common/styles/digitalKyc";
import {
	ACQUISTITION_DATA_STORAGE_KEY_NAME,
	ACQUISTITION_DATA_STORAGE_MODULE_NAME,
	ACTIONCTAERRORINFO,
	LEAD_DATA_STORAGE_KEY_NAME,
	LEAD_DATA_STORAGE_MODULE_NAME,
	formDataHeaders,
} from "../common/constants";
import { processRedirection } from "./api";
import faviconIcon from "../assets/images/ico/favicon.ico";
const airtelEDKey = "A!rt3lOnl!n33ncrypt30n5tr!ngHJS3cur!ty";

export const onLoadAcquisitonKeyEncryption = () => {
	try {
		const dataKey = window.localStorage.getItem(
			`${ACQUISTITION_DATA_STORAGE_MODULE_NAME}${ACQUISTITION_DATA_STORAGE_KEY_NAME}`
		);
		if (dataKey) {
			const parsedKey = JSON.parse(dataKey);
			if (parsedKey && parsedKey?.lob) {
				setInLocalStorage(
					ACQUISTITION_DATA_STORAGE_MODULE_NAME,
					ACQUISTITION_DATA_STORAGE_KEY_NAME,
					parsedKey
				);
			}
		}
	} catch (e) {
		console.error("onLoadAcquisitonKeyEncryption | ERR", e);
	}
};

export const getDecryptedString = (ciphertext) => {
	if (!ciphertext) return ciphertext;
	var keyHex = CryptoJS.enc.Utf8.parse(airtelEDKey);
	// direct decrypt ciphertext
	var decrypted = CryptoJS.DES.decrypt(
		{
			ciphertext: CryptoJS.enc.Base64.parse(ciphertext),
		},
		keyHex,
		{
			mode: CryptoJS.mode.ECB,
			padding: CryptoJS.pad.Pkcs7,
		}
	);
	var message = decrypted.toString(CryptoJS.enc.Utf8);

	//if encryption source was object
	try {
		message = JSON.parse(message);
		return message;
	} catch (err) {
		//if encryption source was string
		return message;
	}
};

export const getEncryptedString = (message) => {
	if (!message) return message;
	if (typeof message === "object") {
		message = JSON.stringify(message);
	} else {
		message = String(message);
	}
	var keyHex = CryptoJS.enc.Utf8.parse(airtelEDKey);
	var encrypted = CryptoJS.DES.encrypt(message, keyHex, {
		mode: CryptoJS.mode.ECB,
		padding: CryptoJS.pad.Pkcs7,
	});
	return encrypted.toString();
};

export const isLocalStorageSupported = () => {
	const testKey = "test";
	const storage = window.localStorage;
	try {
		storage.setItem(testKey, "1");
		storage.removeItem(testKey);
		return true;
	} catch (error) {
		return false;
	}
};

export const getFromLocalStorage = (moduleId, key) => {
	const localStorageKey = `${moduleId + key}`;
	if (!localStorage[localStorageKey]) {
		return;
	}

	if (isLocalStorageSupported()) {
		return Object.assign(
			{},
			getDecryptedString(JSON.parse(localStorage[localStorageKey]))
		);
	}
};

export const setInLocalStorage = (moduleId, key, obj) => {
	const localStorageKey = `${moduleId + key}`;
	if (isLocalStorageSupported()) {
		let cipherText = getEncryptedString(obj);
		cipherText = `"${cipherText}"`;
		localStorage[localStorageKey] = cipherText;
	}
};

export const removeFromLocalStorage = (moduleId, key) => {
	const localStorageKey = `${moduleId + key}`;
	if (localStorage[localStorageKey]) {
		delete localStorage[localStorageKey];
	}
};

export const getEncryptionDetails = () => {
	const encryptionDetails = getFromLocalStorage("kyc", "secure");
	return encryptionDetails;
};

export const getEncryptedRsaString = (message, publicRsaKey) => {
	if (!message || !publicRsaKey) return message;

	var pki = forge.pki;
	var pkey = publicRsaKey;
	var pkeyDer = forge.util.decode64(pkey);

	var pkeyAsn1 = forge.asn1.fromDer(pkeyDer);
	var publicKey = pki.publicKeyFromAsn1(pkeyAsn1);
	// eslint-disable-next-line no-undef
	var encryptedMsg = publicKey.encrypt(message, "RSA-OAEP", {
		md: forge.md.sha256.create(),
		mgf1: {
			md: forge.md.sha1.create(),
		},
	});
	return forge.util.encode64(encryptedMsg);
};

export const getEncryptedMessage = (message) => {
	const keyDetails = getEncryptionDetails();
	const pubKey = keyDetails && keyDetails.publicKey;
	const encryptedMsg = getEncryptedRsaString(message, pubKey);
	return encryptedMsg;
};

/**
 * This function fetches public rsa key, used in encryption of data and store it in local storage
 */
export const fetchPublicRsaKey = async () => {
	const resp = await getPublicKey(paths.getPublicKey);
	const pkey = resp && resp.key;
	const encryptionData = { publicKey: pkey };
	setInLocalStorage("kyc", "secure", encryptionData);
};

/**
 * fetch public key only when it's not present in local storage
 */
export const fetchEncryptionData = async () => {
	const encyptionDetails = getEncryptionDetails();
	if (!encyptionDetails) {
		await fetchPublicRsaKey();
	}
};

export const removeModalBGScroll = (className) => {
	if (
		document.querySelector(`.${className}`) &&
		document.querySelector(`.fixed-bottom-btn`)
	) {
		document.querySelector("body").style.overflow = "hidden";
		document.querySelector(`.${className}`).style.marginBottom = "200px";
		document.querySelector(`.fixed-bottom-btn`).style.bottom = "-90px";
	}
};

export const addModalBGScroll = (className) => {
	if (
		document.querySelector(`.${className}`) &&
		document.querySelector(`.fixed-bottom-btn`)
	) {
		document.querySelector("body").style.overflow = "visible";
		document.querySelector(`.${className}`).style.marginBottom = "0px";
		document.querySelector(`.fixed-bottom-btn`).style.bottom = "0px";
	}
};

export const getFourDigitRandomText = () => {
	return (Math.floor(Math.random() * 10000) + 10000).toString().substring(1);
};

export const dec2hex = (dec) => {
	return ("0" + dec.toString(16)).substr(-2);
};

export const generateId = (len) => {
	var arr = new Uint32Array(len / 2);
	window.crypto.getRandomValues(arr);
	return Array.from(arr, dec2hex).join("");
};

export const getRandomString = () => {
	const randomString = generateId(56);

	var hashed = CryptoJS.SHA256(randomString).toString(CryptoJS.enc.Base64);

	hashed = hashed.replaceAll("=", "");
	hashed = hashed.replaceAll("+", "-");
	hashed = hashed.replaceAll("/", "_");

	return {
		randomString: randomString,
		hashed: hashed,
	};
};

export const getPositionCoord = async (setShowLoader) => {
	let location;
	let counter = 0;
	setShowLoader && setShowLoader(true);
	try {
		window.navigator?.geolocation?.getCurrentPosition &&
			window.navigator?.geolocation?.getCurrentPosition((position) => {
				location = position;
			});
	} catch (ex) {
		console.log(ex);
	}
	return new Promise((resolve, reject) => {
		const timer = setInterval(() => {
			if (location && location.coords) {
				const latitude = location.coords.latitude;
				const longitude = location.coords.longitude;
				const leadData = getFromLocalStorage(
					LEAD_DATA_STORAGE_MODULE_NAME,
					LEAD_DATA_STORAGE_KEY_NAME
				);
				setShowLoader && setShowLoader(false);
				setInLocalStorage(
					LEAD_DATA_STORAGE_MODULE_NAME,
					LEAD_DATA_STORAGE_KEY_NAME,
					{ latitude, longitude, ...leadData }
				);
				resolve(location.coords.longitude.toString());
				clearInterval(timer);
			}
			if (counter >= 20) {
				reject(undefined);
				clearInterval(timer);
				setShowLoader && setShowLoader(false);
			}
			counter++;
		}, 1500);
	});
};

export const getLocationPermission = async (setShowLoader) => {
	if (navigator?.geolocation && navigator?.geolocation?.getCurrentPosition) {
		setShowLoader && setShowLoader(true);
		await navigator?.geolocation?.getCurrentPosition(
			(position) => {
				const latitude = position.coords.latitude;
				const longitude = position.coords.longitude;
				const leadData = getFromLocalStorage(
					LEAD_DATA_STORAGE_MODULE_NAME,
					LEAD_DATA_STORAGE_KEY_NAME
				);
				setShowLoader && setShowLoader(false);
				setInLocalStorage(
					LEAD_DATA_STORAGE_MODULE_NAME,
					LEAD_DATA_STORAGE_KEY_NAME,
					{ latitude, longitude, ...leadData }
				);
			},
			() => { }
		);
	} else {
		setShowLoader && setShowLoader(false);
		alert(geoLocationErrorMessage);
	}
};

export const getDraftOrderBody = () => {
	const acquisitionLeadData = getFromLocalStorage(
		ACQUISTITION_DATA_STORAGE_MODULE_NAME,
		ACQUISTITION_DATA_STORAGE_KEY_NAME
	);
	const leadData = getFromLocalStorage(
		LEAD_DATA_STORAGE_MODULE_NAME,
		LEAD_DATA_STORAGE_KEY_NAME
	);
	return {
		alternateNumber: acquisitionLeadData.alternateNumber,
		channel: leadData.channel,
		interactionId: leadData.id,
		leadSchedulerId: leadData.id,
		lob: acquisitionLeadData.lob,
	};
};

export const getPhotoUploadBody = (
	file,
	location,
	imageType,
	matchFaceWithImage
) => {
	const leadData = getFromLocalStorage(
		LEAD_DATA_STORAGE_MODULE_NAME,
		LEAD_DATA_STORAGE_KEY_NAME
	);
	const acquisitionLeadData = getFromLocalStorage(
		ACQUISTITION_DATA_STORAGE_MODULE_NAME,
		ACQUISTITION_DATA_STORAGE_KEY_NAME
	);
	const formData = new FormData();
	formData.append("imageValue", file);
	formData.append("interactionId", leadData.id);
	formData.append("latitude", location.latitude);
	formData.append("longitude", location.longitude);
	formData.append("lob", acquisitionLeadData?.lob || "postpaid");
	formData.append("imageType", imageType);
	formData.append("documentType", "aadhaar");
	if (matchFaceWithImage) {
		formData.append("matchFaceWithImage", matchFaceWithImage);
	}

	return formData;
};


export const getDisabilityImageUploadBody = (
	file,
	location,
	imageType,
	documentType
) => {
	const leadData = getFromLocalStorage(
		LEAD_DATA_STORAGE_MODULE_NAME,
		LEAD_DATA_STORAGE_KEY_NAME
	);
	const formData = new FormData();
	formData.append("imageValue", file);
	formData.append("interactionId", leadData?.id);
	formData.append("latitude", location?.latitude);
	formData.append("longitude", location?.longitude);
	formData.append("lob", 'postpaid');
	formData.append("imageType", imageType);
	formData.append("documentType", documentType);

	return formData;
};

export const getVideoUploadBody = (file, location) => {
	const leadData = getFromLocalStorage(
		LEAD_DATA_STORAGE_MODULE_NAME,
		LEAD_DATA_STORAGE_KEY_NAME
	);
	const acquisitionLeadData = getFromLocalStorage(
		ACQUISTITION_DATA_STORAGE_MODULE_NAME,
		ACQUISTITION_DATA_STORAGE_KEY_NAME
	);
	const formData = new FormData();
	formData.append("videoValue", file);
	formData.append("interactionId", leadData.id);
	formData.append("latitude", location.latitude);
	formData.append("longitude", location.longitude);
	formData.append("lob", acquisitionLeadData?.lob || "postpaid");
	formData.append("videoType", "video");
	formData.append("source", "ecaf");
	formData.append("documentType", "video");
	formData.append("journey", "skyc");
	formData.append("retry", "false");

	return formData;
};

export const closeWebView = () => {
	localStorage.clear();
	processRedirection(
		{
			deeplink: {
				iuri: "myairtel://home",
				uri: "myairtel://home",
				wuri: "https://www.airtel.in/",
			},
		},
		{}
	);
};
export const getPhotoErrorMessage = (error, fieldData, exception) => {
	if (String(error).includes("white background")) {
		return fieldData.attributes.whiteBgError;
	} else if (String(error).includes("phone/video")) {
		return fieldData.attributes.phoneErrorMessage;
	}
	else if (error && exception) {
		return ACTIONCTAERRORINFO.COMMONERRORMSG;
	}
	return fieldData.attributes.photoErrorMessage;
};

export const getAuthHeaders = () => {
	const leadData = getFromLocalStorage(
		LEAD_DATA_STORAGE_MODULE_NAME,
		LEAD_DATA_STORAGE_KEY_NAME
	);
	let authHeaders = {};

	if (leadData["x-skyc-token"] && leadData["x-uid-token"]) {
		authHeaders = {
			"x-skyc-token": leadData["x-skyc-token"],
			"x-uid-token": leadData["x-uid-token"],
		};
	}
	const requestHeaders = {
		...formDataHeaders,
		...authHeaders,
	};

	return requestHeaders;
};

export const getWaterMarkedImage = async (img, reader) => {

	const canvas = document.createElement("canvas");
	const context = canvas.getContext("2d");

	const canvasWidth = 335;
	const canvasHeight = 260;

	canvas.width = 335;
	canvas.height = 260;
	const imgageElement = new Image();
	imgageElement.src = img;
	imgageElement.onload = async () => {
		context.drawImage(imgageElement, 0, 0, canvasWidth, canvasHeight);
		context.fillStyle = "black";
		context.font = "regular 25px serif";
		context.fillText(new Date().toLocaleString(), 10, canvasHeight - 35);
		context.fillText(
			`${location.latitude},${location.longitude}`,
			10,
			canvasHeight - 20
		);
		const result = await fetch(faviconIcon);
		const blob = await result.blob();
		const image = await createImageBitmap(blob);
		context.translate(10, canvasHeight - 80);
		context.drawImage(image, 0, 0, 20, 20);
		context.fill();
		const photo = canvas.toDataURL("image/jpeg")


		const file = await fetch(photo)
			.then((res) => res.blob())
			.then(async (blob) => {
				const file = new File([blob], "image.jpeg", { type: "image/jpeg" });
				return file;
			});

		if (reader) {
			reader.formData = getDisabilityImageUploadBody(file, location, reader.documentType.toUpperCase(), reader.documentType);
			reader.readAsDataURL(file);
		}
	}

};
export const getFetchGeoLocation = () => {
	const promised = new Promise((resolve, reject) => {
		if (window.MyAirtelAppReact?.fetchCurrentLocation) {
			window.getLocation = (status) => {
				if (status) {
					resolve(status);
				}
				else {
					resolve(status);
				}
			};
			window.MyAirtelAppReact?.fetchCurrentLocation("getLocation");
		} else {
			reject(new Error('Failed to fetch location'));
		}
	});
	return promised;
}


export const getFetchGeoLocationIos = ({ setStatus, waitTime = 20, retry = 4 }) => {
	try {
		let result = undefined;
		let counter = 0;
		const getLocation = (data) => {
			result = data;
			return data;
		};
		window.app["getLocation"] = getLocation;
		window["getLocation"] = getLocation;
		const payload = {
			'eventName': "fetchCurrentLocation",
			'callback': "getLocation"
		}

		window.webkit.messageHandlers.triggerAppEvent.postMessage(payload);
		return new Promise((resolve, reject) => {
			setStatus("inside Promise")
			const timer = setInterval(() => {
				setStatus("inside Promise interval", counter, result)
				if (result) {
					resolve(result);
					clearInterval(timer);
				}
				if (counter >= retry) {
					// eslint-disable-next-line prefer-promise-reject-errors
					reject(undefined);
					clearInterval(timer);
				}
				counter++;
			}, waitTime);
		})
	} catch (ex) {
		setStatus("catch")
	}
}